import React, { useCallback, useEffect, useState } from 'react';
import HeadSub from '../../../../components/comm/HeadSub';
import { fromRecDe, getWalkList } from '../../../../api/walkAPI';
import { formatRecordDate } from '../../../../utils/steps';
import style from './StepsRecordList.module.css';

/**
 * 걸음수 전체 기록.
 *
 * 여기는 삼성 헬스가 아니라 **서버**를 읽는다. 단말 쪽 기록은 기기가 바뀌면 과거가 날아가지만
 * 서버에는 동기화된 기록이 계속 쌓이기 때문이다.
 * 저장은 대시보드/홈 진입 시 훅이 알아서 돌린다.
 *
 * 서버가 날짜당 최신 1건만 최신순으로 주므로 여기서 정렬·중복 제거를 하지 않는다.
 */
const StepsRecordList = () => {
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const load = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            setRecords(await getWalkList());
        } catch (e) {
            setError('걸음수 기록을 불러오지 못했습니다.');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    const renderBody = () => {
        if (loading) {
            return (
                <div className={style['stpes-infom-box']}>
                    <div className={style['inner-box']}>
                        <p>걸음수를 불러오는 중입니다…</p>
                    </div>
                </div>
            );
        }

        if (error) {
            return (
                <div className={style['stpes-infom-box']}>
                    <div className={style['inner-box']}>
                        <p>{error}</p>
                        <button className="btn" data-btn-type="fill-main" data-btn-size="sm"
                            onClick={load}>
                            <span>다시 시도</span>
                        </button>
                    </div>
                </div>
            );
        }

        if (records.length === 0) {
            return (
                <div className={style['stpes-infom-box']}>
                    <div className={style['inner-box']}>
                        <p>아직 기록된 걸음수가 없습니다.</p>
                    </div>
                </div>
            );
        }

        return records.map((r) => (
            <div key={r.recDe} className={style['stpes-infom-box']}>
                <div className={style['inner-box']}>
                    <ul>
                        <li><p>걸음수</p><p><span>{Number(r.steps || 0).toLocaleString()}</span> 걸음</p></li>
                        <li><p>소모 칼로리</p><p><span>{r.cnsumCalor ?? 0}</span> kcal</p></li>
                        <li><p>걸은 거리</p><p><span>{r.walkDstnc ?? 0}</span> km</p></li>
                    </ul>
                    <span>{formatRecordDate(fromRecDe(r.recDe))}</span>
                </div>
            </div>
        ));
    };

    return (
        <>
            <HeadSub title="걸음수 전체 기록" />
            <div id="sub-content">
                <div className="inner-wrap" data-pad="normal">
                    <div className={style['stpes-infom-wrap']}>
                        {renderBody()}
                    </div>
                </div>
            </div>
        </>
    );
};

export default StepsRecordList;
